<div class="p-5 max-w-6xl mx-auto">
  <div class="flex justify-between items-center mb-5">
  <h1 class="text-2xl font-medium">{{ 'water-services.list.title' | translate }}</h1>
    <button matButton="filled" (click)="openCreateDialog()" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2">
      <mat-icon>add</mat-icon>
      {{ 'water-services.list.create' | translate }}
    </button>
  </div>

  @if (waterServicesResource.isLoading()) {
    <div class="flex justify-center items-center min-h-[300px]">
      <mat-spinner />
    </div>
  } @else {
    <mat-card>
      <mat-card-content>
        @let waterServices = waterServicesResource.value();
        @if (!waterServices || waterServices?.length === 0) {
          <div class="text-center p-10">
            <mat-icon class="!text-6xl !w-16 !h-16 !text-gray-400 mb-4">water</mat-icon>
            <p class="text-gray-700 text-base mb-6">{{ 'water-services.list.no-services' | translate }}</p>
            <button matButton="filled" (click)="openCreateDialog()" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2">
              <mat-icon>add</mat-icon>
              {{ 'water-services.list.add-first' | translate }}
            </button>
          </div>
        } @else {
          <table mat-table [dataSource]="waterServices" class="w-full divide-y divide-gray-200">
            <!-- Water Column -->
            <ng-container matColumnDef="water">
              <th mat-header-cell *matHeaderCellDef>{{ 'water-services.list.water' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.waterTitle }}</td>
            </ng-container>

            <!-- Updated Date Column -->
            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef>{{ 'water-services.list.updated-date' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                {{ element.updatedAt | date: 'short' }}
              </td>
            </ng-container>

            <!-- Services Count Column -->
            <ng-container matColumnDef="servicesCount">
              <th mat-header-cell *matHeaderCellDef class="!text-right">{{ 'water-services.list.services' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="!text-right">
                {{ element.servicesCount }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ 'water-services.list.actions' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-icon-button
                  color="primary"
                  (click)="editWater(element.waterId)"
                  matTooltip="{{ 'water-services.list.edit' | translate }}">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  (click)="deleteWater(element.waterId, element.waterTitle, $event)"
                  matTooltip="{{ 'water-services.list.delete' | translate }}">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="editWater(row.waterId)"
              class="bg-white hover:bg-gray-100 cursor-pointer"></tr>
          </table>
        }
      </mat-card-content>
    </mat-card>
  }
</div>
